export let focusedOtherRollupAriaLabel = "QOeL1b";
export default {focusedOtherRollupAriaLabel};